import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isSidebarOpen: false
}

const slice = createSlice({
  name: 'adminSettings',
  initialState,
  reducers: {}
})

export const { reducer } = slice
